const reportDB = require('../../../../../components/report/report-db')
const report   = require('../../../../../components/report/report')
const style    = require('../../../../../components/report/report-style')
const css      = style.get()
const settings = require('../../../../../js-handler/settings')
const timeDate = require('../../../../../js-handler/time-date')
const timeTime = require('../../../../../js-handler/time-time')

export function start(detail) {

    const phpFile = 'server/php/sql/report.php' 

    if (detail.source == 'fullcont') {
        const fullcontProvider = document.getElementById('provider-fullcont')
        let dataDbid = '';

        dataDbid = fullcontProvider.getAttribute('data-dbid')
        detail.inf = { entity: 'provider', report: 'account-all-profit', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => {

            insert(detail, data)

        })
    } else if (detail.source == 'dt') {
        let dataDbid = '';
        dataDbid = detail.dbid
        detail.inf = { entity: 'provider', report: 'account-all-profit', id: dataDbid }

        reportDB.select(detail, phpFile, (data) => { 

            insert(detail, data)

        })
    }else{
        detail.inf = { entity: 'provider', report: 'account-all-profit'}

        reportDB.select(detail, phpFile, (data) => { 

            insert(detail, data)
    
        })
    }

}/**/

function insert(detail, data) {

    report.show(detail, () => {

        const pageTarget = document.getElementById('report-page-right')
        const body = generate(data)

        pageTarget.insertAdjacentHTML("beforeend", body)

    })

}/*insert*/


function generate(data) {

    var body = ''
    body    += generateHeader()
    body    += generateTop(data)
    body    += generateTable(data)
    body    += `</div> <!-- dataCont -->`
    body    += `<div class="report-page">`

    return body
}

function generateHeader() {

    var header = ''
    header += `<div class="report-page" id="miDiv5" ${css.table}>`
    header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove" } ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>All Providers Statement</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

    header += `
                    <div class="dataCont">
                        <h1  ${css.f32}>Provider Profit Aging Report</h1>
                        <p   ${css.f14} >
                                This is a financial document that provides a summary of earning that a company earned to its suppliers or vendors.
                        </p>
            `
    return header


}


function generateTop(data) {

    let company_name     = "";
    let current_dateTime = "";

    //if no data found
    if (data.length > 0) {
        company_name     = data[0].company_name;
        current_dateTime = data[0].current_dateTime;
    } else {
        let config       = settings.getData()
        company_name     = config.company;
        current_dateTime = timeDate.getdateshort() + ' ' + timeTime.formatAMPM();
    }

    var table = `<br><br><h1 style="text-align: center;">${company_name}</h1>
      <h2 style="text-align: center;"Accounts Profits All Report</h2>
      <h2 style="text-align: center;">As Of ${current_dateTime}</h2>
      `;


    return table

}/**/

function generateTable(data) { //console.log('data>>>', data) 

    var totals = {
        total_last_24_hours: 0,
        total_last_7_days: 0,
        total_last_15_days: 0,
        total_last_30_days: 0,
        total_last_90_days: 0,
        total_over_90_days: 0,
        grandTotal: 0
    };
    var nextFormat = 0;


    var table = `
    <h2 ${css.tableTitle}>Providers Vs Profits</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
       <th ${css.th}>provider</th>
       <th ${css.th}>Last 24 hours</th>
       <th ${css.th}>Last 7 days</th>
       <th ${css.th}>Last 15 days</th>
       <th ${css.th}>Last 30 days</th>
       <th ${css.th}>Last 90 days</th>
       <th ${css.th}>Over 90 days</th>
       <th ${css.th}>Total</th>   
       </tr> 
       `
    //if no data found
    if (data.length == 0) {
        table += `
                <tr>
                    <td ${css.td} colspan="8"  ><div align="center"><h3>No Profits Were Found.</h3></div></td>
                </tr> 
                 `

        table += `</table>`

        return table
    }

    for (let i = 0; i < data.length; i++) {

        let detailHtml_24_hours = parseFloat(data[i].last_24_hours.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
         "source":"dt", "period":"1" } ] }'` : '';

        let detailHtml_7_days   = parseFloat(data[i].last_7_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
        "source":"dt", "period":"2" } ] }'`  : '';

        let detailHtml_15_days  = parseFloat(data[i].last_15_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
        "source":"dt", "period":"3" } ] }'`   : '';

        let detailHtml_30_days  = parseFloat(data[i].last_30_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
        "source":"dt", "period":"4" } ] }'` : '';

        let detailHtml_90_days  = parseFloat(data[i].last_90_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
        "source":"dt", "period":"5" } ] }'`   : '';

        let detailHtml_over_90_days = parseFloat(data[i].over_90_days.replace(/[$,]/g, '')) > 0 ? `class='tdClick'  data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"provider", "elem":"report", "reportType":"profitPeriod", "entity":"provider", "dbid":"${data[i].provider_id}",
            "source":"dt", "period":"6" } ] }'`  : '';

        totals.total_last_24_hours += parseFloat(data[i].last_24_hours.replace(/[$,]/g, ''));
        totals.total_last_7_days   += parseFloat(data[i].last_7_days.replace(/[$,]/g, ''));
        totals.total_last_15_days  += parseFloat(data[i].last_15_days.replace(/[$,]/g, ''));
        totals.total_last_30_days  += parseFloat(data[i].last_30_days.replace(/[$,]/g, ''));
        totals.total_last_90_days  += parseFloat(data[i].last_90_days.replace(/[$,]/g, ''));
        totals.total_over_90_days  += parseFloat(data[i].over_90_days.replace(/[$,]/g, ''));
        totals.grandTotal          += parseFloat(data[i].total_earnings.replace(/[$,]/g, ''));

        table += `
            <tr ${rowStyle(i)}>
              <td ${css.td}>${data[i].provider_name}</td>
              <td ${css.td} ${detailHtml_24_hours}>${data[i].last_24_hours}</td>
              <td ${css.td} ${detailHtml_7_days}>${data[i].last_7_days}</td>
              <td ${css.td} ${detailHtml_15_days}>${data[i].last_15_days}</td>
              <td ${css.td} ${detailHtml_30_days}>${data[i].last_30_days}</td>
              <td ${css.td} ${detailHtml_90_days}>${data[i].last_90_days}</td>
              <td ${css.td} ${detailHtml_over_90_days}>${data[i].over_90_days}</td>
              <td ${css.td}>${cashVal(parseFloat(data[i].total_earnings.replace(/[$,]/g, '')))}</td>
            </tr> 
        `
        nextFormat = i + 1;

    }

    //PRINITNG EACH COLUMM TOTAL
    table += `
        <tr ${rowStyle(nextFormat)}>
          <td style="text-align: right;"><h2>Total</h2></td>
          <td ${css.td} ><h3>${cashVal(totals.total_last_24_hours)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.total_last_7_days)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.total_last_15_days)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.total_last_30_days)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.total_last_90_days)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.total_over_90_days)}</h3></td>
          <td ${css.td} ><h3>${cashVal(totals.grandTotal)}</h3></td>
        </tr> 
        `

    table += `</table>`

    return table

}

function cashVal(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}


function rowStyle(i) {

    if (i % 2 === 0) { return '' }
    return css.trGray

}
